module.exports = __webpack_public_path__ + "media/images/recruit/environments/ph_01-871f3f957d65f55d53bbe5f6e120f5bd.jpg";